import React from "react";
import style from './index.module.scss';

export const Footer = () => {
    return (
        <div className={style.footer}>
            <div className={style.footer_text}>
                Copyright © 2021 安徽瑞轩供应链科技有限公司. All Rights Reserved.
                <a
                    id="icp_record"
                    href="https://beian.miit.gov.cn/"
                    target="_blank"
                    rel="noreferrer"
                >
                    皖ICP备2021005989号
                </a>
            </div>
        </div>
    )
}
